__turbopack_context__.v({
  "armLift": "NozPathWalk-module__COTAeq__armLift",
  "armWiggle": "NozPathWalk-module__COTAeq__armWiggle",
  "badge": "NozPathWalk-module__COTAeq__badge",
  "badgeLayer": "NozPathWalk-module__COTAeq__badgeLayer",
  "head": "NozPathWalk-module__COTAeq__head",
  "layer": "NozPathWalk-module__COTAeq__layer",
  "noz": "NozPathWalk-module__COTAeq__noz",
  "noz-badge-breathe": "NozPathWalk-module__COTAeq__noz-badge-breathe",
  "noz-wave-wiggle": "NozPathWalk-module__COTAeq__noz-wave-wiggle",
  "nozLayer": "NozPathWalk-module__COTAeq__nozLayer",
  "sceneLayer": "NozPathWalk-module__COTAeq__sceneLayer",
  "skyline": "NozPathWalk-module__COTAeq__skyline",
  "track": "NozPathWalk-module__COTAeq__track",
  "waving": "NozPathWalk-module__COTAeq__waving",
});
